import React from "react";
import { Link } from "react-router-dom";
import { Wine } from "lucide-react";

const EFFECTIVE_DATE = "23 July 2026";
const CONTACT_EMAIL = "tourgourmania@gmail.com";

const S = {
  page: { minHeight: "100vh", background: "#F2F5EC", fontFamily: "'Inter',sans-serif", padding: "32px 20px 80px" },
  box: { maxWidth: 720, margin: "0 auto" },
  h1: { fontFamily: "'Playfair Display',serif", fontSize: 26, color: "#1E2C14", margin: "0 0 4px" },
  meta: { fontSize: 12, color: "#6A7E58", marginBottom: 28 },
  h2: { fontSize: 15, fontWeight: 700, color: "#2C3820", margin: "28px 0 8px" },
  p: { fontSize: 13, color: "#3A4A2E", lineHeight: 1.6, margin: "0 0 12px" },
  li: { fontSize: 13, color: "#3A4A2E", lineHeight: 1.6, margin: "0 0 6px" },
  link: { color: "#886070", textDecoration: "none" },
};

export default function TermsPage() {
  return (
    <div style={S.page}>
      <div style={S.box}>
        <Wine size={24} color="#6B2737" style={{ marginBottom: 10 }} />
        <h1 style={S.h1}>Terms of Service</h1>
        <p style={S.meta}>Effective {EFFECTIVE_DATE} · <Link to="/privacy" style={S.link}>Privacy Policy</Link></p>

        <p style={S.p}>
          By creating an account or booking a tasting through Wine4Collect, you agree to these terms. Please
          also read our <Link to="/privacy" style={S.link}>Privacy Policy</Link>, which explains how we handle
          your personal data.
        </p>

        <h2 style={S.h2}>The service</h2>
        <p style={S.p}>
          Wine4Collect helps you plan wine-tasting tours and request bookings at participating wineries. We
          connect travelers with wineries; the tasting visit itself is provided by the winery, not by us.
        </p>

        <h2 style={S.h2}>Bookings</h2>
        <p style={S.p}>
          A booking request is not confirmed until the winery accepts it. Cancellation and no-show policies are
          set by each winery. We send booking-related notifications by email on a best-effort basis and are not
          liable for delivery failures outside our control.
        </p>

        <h2 style={S.h2}>Booking without an account</h2>
        <p style={S.p}>
          If you book a tasting without creating an account, we ask only for your name and email so the winery
          can confirm your visit. That email is pseudonymized immediately and automatically deleted within 24
          hours of your visit — see our <Link to="/privacy" style={S.link}>Privacy Policy</Link> for how. Every
          booking status email also includes a link to delete it sooner, if you'd rather not wait. If you choose
          early deletion, please understand: the winery will have no way to reach you if your booking needs to be
          changed or cancelled, and no way to contact you if a legal or contractual issue arises from the visit.
          Deleting your email does not cancel or change the booking itself.
        </p>

        <h2 style={S.h2}>Accounts</h2>
        <p style={S.p}>
          You're responsible for keeping your login credentials confidential and for the accuracy of the
          information you provide. Winery managers are responsible for the accuracy of their listing content.
        </p>

        <h2 style={S.h2}>Acceptable use</h2>
        <p style={S.p}>
          Don't use the service to submit false booking requests, scrape or resell winery data, or attempt to
          access accounts or data that aren't yours.
        </p>

        <h2 style={S.h2}>Availability</h2>
        <p style={S.p}>
          This is a prototype service and may change, be interrupted, or be discontinued without notice.
        </p>

        <h2 style={S.h2}>Contact</h2>
        <p style={S.p}>
          Questions about these terms: <a href={`mailto:${CONTACT_EMAIL}`} style={S.link}>{CONTACT_EMAIL}</a>.
        </p>
      </div>
    </div>
  );
}
